module.exports = __webpack_public_path__ + "static/N2N7-3355a3e8b4b0c1484c6d6296bfd62160.jpg";